import { ref, watch } from "vue";

const state = ref({ links: [] })

const savedLinks = localStorage.getItem("fem-links")
if (savedLinks !== null) {
    state.value.links = ref(JSON.parse(savedLinks))
}

watch(state.value.links, (val) => {
    localStorage.setItem("fem-links", JSON.stringify(val))
}, { deep: true })


export default state